import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const STARS = '★★★★★';

/** Average + proportional-fill star row + review count, e.g. "4.9 ★★★★★ 126 reviews". Renders nothing if count is 0. */
const StarRating = ({ average = 0, count = 0, size = 15, onInfoClick, InfoIcon }) => {
  const { t } = useLanguage();
  if (!count) return null;
  const pct = Math.max(0, Math.min(100, (average / 5) * 100));

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
      <span style={{ fontWeight: '700', color: '#2d3748', fontSize: size * 0.95 }}>{average.toFixed(1)}</span>
      <span style={{ position: 'relative', display: 'inline-block', lineHeight: 1, fontSize: size, letterSpacing: '1px' }}>
        <span style={{ color: '#e2e8f0' }}>{STARS}</span>
        <span style={{ position: 'absolute', left: 0, top: 0, width: `${pct}%`, overflow: 'hidden', color: '#f6ad55', whiteSpace: 'nowrap' }}>{STARS}</span>
      </span>
      <span style={{ color: '#3182ce', fontSize: size * 0.75, whiteSpace: 'nowrap' }}>
        {count} {t('findAttorney.ratingReviews')}
      </span>
      {InfoIcon}
    </div>
  );
};

export default StarRating;
